/** Add a presentation class to flat lists of questions, preserving their content. */
export function formatQuestionLists(html: string): string {
  if (!/<ul\b/i.test(html)) return html;
  const document = new DOMParser().parseFromString(html, "text/html");
  let changed = false;
  Array.from(document.querySelectorAll("ul")).forEach(list => {
    const items = Array.from(list.children);
    if (items.length < 2 || list.querySelector("ul, ol") || list.parentElement?.closest("ul, ol")) return;
    if (!items.every(item => item.tagName === "LI" && /\?\s*$/.test(item.textContent || ""))) return;
    list.classList.add("cms-question-list");
    list.setAttribute("role", "list");
    changed = true;
  });
  return changed ? document.body.innerHTML : html;
}
